import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import HafaSambandAlert from "../../components/hafa_samband_alert";
import CustomAlert from "../../components/alert";
import bgImg from "../../resources/runstykki.cover.jpeg";

const INPUT = "w-full h-11 px-4 bg-white border border-amber-200 rounded-xl text-stone-800 font-serif text-sm focus:outline-none focus:ring-2 focus:ring-[#C29979]/30";
const LABEL = "block text-xs font-semibold text-stone-500 uppercase tracking-wide mb-1.5";

export const HafaSamband = () => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [HafaSamband_alertIsOpen, setHafaSambandAlertIsOpen] = useState(false);
    const [alertIsOpen, setAlertIsOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { id: uuidv4(), name, phone, email, message };
        try {
            await fetch('https://api.kallabakari.is/api/comments', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });
            setHafaSambandAlertIsOpen(true);
            setName(''); setPhone(''); setEmail(''); setMessage('');
        } catch {
            setAlertIsOpen(true);
            setAlertMessage('Villa kom upp við að senda skilaboð. Vinsamlegast reyndu aftur síðar.');
        }
    };

    return (
        <div className="min-h-screen bg-[#F5E4CA] flex flex-col md:flex-row">
            <CustomAlert isOpen={alertIsOpen} onClose={() => setAlertIsOpen(false)} message={alertMessage} />
            <HafaSambandAlert isOpen={HafaSamband_alertIsOpen} onClose={() => setHafaSambandAlertIsOpen(false)} />

            {/* Image panel */}
            <div className="w-full md:w-2/5 flex-shrink-0 relative">
                <img src={bgImg} alt="Kallabakarí" className="w-full h-52 md:h-full object-cover" />
                <div className="absolute inset-0 bg-black/15" />
            </div>

            {/* Form panel */}
            <div className="flex-1 flex flex-col justify-center px-8 py-16 md:px-14">
                <h1 className="font-serif text-stone-900 text-3xl mb-2">Hafa Samband</h1>
                <div className="w-12 h-0.5 bg-[#C29979] mb-8"></div>

                <form className="space-y-4" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className={LABEL}>Nafn</label>
                            <input className={INPUT} type="text" value={name} onChange={e => setName(e.target.value)} required />
                        </div>
                        <div>
                            <label className={LABEL}>Símanúmer</label>
                            <input className={INPUT} type="tel" value={phone} onChange={e => setPhone(e.target.value)} required />
                        </div>
                    </div>
                    <div>
                        <label className={LABEL}>Netfang</label>
                        <input className={INPUT} type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                    </div>
                    <div>
                        <label className={LABEL}>Skilaboð</label>
                        <textarea
                            className="w-full px-4 py-3 bg-white border border-amber-200 rounded-xl text-stone-800 font-serif text-sm focus:outline-none focus:ring-2 focus:ring-[#C29979]/30 resize-none"
                            rows={5}
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full py-3.5 rounded-xl bg-[#C29979] text-white font-serif uppercase tracking-wide text-sm hover:bg-[#b08060] transition-colors"
                    >
                        Senda
                    </button>
                </form>

                <div className="mt-10 pt-8 border-t border-amber-100 space-y-2">
                    <p className="font-serif text-stone-500 text-sm">Símanúmer: <span className="text-stone-700">431-1644</span></p>
                    <p className="font-serif text-stone-500 text-sm">Netfang: <span className="text-stone-700">kallabakari@kallabakari.is</span></p>
                </div>
            </div>
        </div>
    );
}

export default HafaSamband;
